// Compact, locale-aware labels for heatmap rows.
// Row label example (pt-BR): "Sáb 12/09"; description: "sábado, 12 de setembro de 2026".

const toIntlLocale = locale => (locale || 'pt-BR').replace('_', '-');

const capitalize = value =>
  value ? value.charAt(0).toLocaleUpperCase() + value.slice(1) : value;

export const formatHeatmapRowLabel = (date, locale) => {
  const intlLocale = toIntlLocale(locale);
  const weekday = new Intl.DateTimeFormat(intlLocale, { weekday: 'short' })
    .format(date)
    .replace(/\.$/, '');
  const dayMonth = new Intl.DateTimeFormat(intlLocale, {
    day: '2-digit',
    month: '2-digit',
  }).format(date);
  return `${capitalize(weekday)} ${dayMonth}`;
};

export const formatHeatmapRowDescription = (date, locale) =>
  new Intl.DateTimeFormat(toIntlLocale(locale), {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
